import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { FranchiseExtended, FranchisePageData } from '@/services/FranchiseService'
import { Project } from '@/services/ProjectsService'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { FranchiseHero } from './FranchiseHero'
import { FranchisePoster } from './FranchisePoster'
import { FranchiseProject } from './FranchiseProject'

interface FranchiseViewProps {
  franchise: FranchiseExtended
  pageData?: FranchisePageData | null
  isGuildMember: boolean
  slug: string
  hasWatchableReasons: boolean
}

export const FranchiseView: React.FC<FranchiseViewProps> = ({
  franchise,
  pageData,
  isGuildMember,
  slug,
  hasWatchableReasons,
}) => {
  const defaultProject =
    franchise?.projects?.filter((project) => project?.projectType === 'movie')[0] ?? franchise?.projects?.[0]

  return (
    <main className="bg-core-gray-950">
      <FranchiseHero
        pageData={pageData}
        isGuildMember={isGuildMember}
        slug={slug}
        defaultProject={defaultProject as Project}
        franchise={franchise}
      />
      <section id="franchise-projects" className="relative bg-gradient-to-t from-transparent to-[rgba(0,0,0,0.25)]">
        <ResponsiveBackgroundImage
          className="fixed left-0 top-0 z-0 h-full w-full bg-cover"
          src={getCloudinaryImageUrl({
            path: 'v1734024788/angel-studios/franchises/bg-image-franchise-page',
          })}
        />
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(0deg, #141414 7.85%, rgba(20, 20, 20, 0.00) 100%) ',
          }}
        />
        {franchise?.projects
          ?.filter((project) => project)
          ?.sort((a, b) => {
            const watchSequenceA = a?.franchiseDetails?.watchSequence ?? 0
            const watchSequenceB = b?.franchiseDetails?.watchSequence ?? 0
            return watchSequenceA - watchSequenceB
          })
          ?.map((project) => {
            if (!project) return null
            return (
              <FranchiseProject
                project={project as Project}
                key={project?.slug}
                isGuildMember={isGuildMember}
                defaultProject={defaultProject as Project}
                pageData={pageData}
                hasWatchableReasons={hasWatchableReasons}
              />
            )
          })}
      </section>
      <FranchisePoster pageData={pageData} />
    </main>
  )
}
